module.exports = __webpack_public_path__ + "img/Drop Down Menu - Green - Selected.4a05149f.png";